import React, { isValidElement } from 'react';
import { Box, Typography } from '@mui/material';

// Columns the compact row hides by default. They appear in the expanded panel instead.
export const DEFAULT_HIDDEN_COLUMNS = [
    'founder_name',
    'source',
    'pitch_reels',
    'location',
    'category_sub_sector',
    'pitch_deck',
    'links',
    '_allocated_amount',
];

// Text and numbers are shown as they are; ready-made cells (Reel, Pitch Deck, Links) are shown
// as they are too. Empty values fall back to a dash.
const displayValue = (value) => {
    if (isValidElement(value)) return value;
    return (typeof value === 'string' || typeof value === 'number') && String(value).trim() !== '' ? String(value) : '-';
};

// Shows the columns the table is hiding for this view (`hiddenColumns`), labelled with their
// column header, so the panel adds information instead of repeating the row.
const StartupRowDetails = ({ row, hiddenColumns = [] }) => {
    const fields = hiddenColumns.filter((col) => !['checkbox', 'actions'].includes(col.accessor));
    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px 24px', px: '56px', py: '14px' }}>
            {fields.map((col) => (
                <Box key={col.accessor} sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontSize: '0.75rem', color: '#838383', mb: '2px' }}>{col.Header}</Typography>
                    <Typography sx={{ fontSize: '0.8125rem', color: '#202020', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {displayValue(row?.[col.accessor])}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default StartupRowDetails;
